import Link from 'next/link'
import { FC, useState } from 'react'

import styles from '@/screens/Sitemap/Sitemap.module.scss'

export interface LinkItemType {
	title: string
	path: string
	children?: LinkItemType[]
}

export interface LinkItemProps {
	item: LinkItemType
	level?: number
}

export const LinkItem: FC<LinkItemProps> = ({ item, level = 1 }) => {
	const hasChildren = item.children && item.children.length > 0
	const [isExpanded, setIsExpanded] = useState(true)

	const toggleExpanded = () => {
		setIsExpanded(prev => !prev)
	}

	return (
		<li className={styles.item}>
			<div className={styles.subsectionHeader}>
				<Link
					prefetch={false}
					href={!!item.path ? item.path : `/`}
					className={`${styles.link} ${level === 1 || hasChildren ? styles.bold : ''} ${
						!item.path ? styles.disabled : ''
					}`}>
					{item.title}
				</Link>
				{hasChildren && (
					<button className={styles.showMoreButton} onClick={toggleExpanded} type="button">
						{isExpanded ? `Скрыть` : `Показать (${item.children.length})`}
					</button>
				)}
			</div>
			{hasChildren && (
				<div className={styles.subsectionWrapper}>
					<ul
						className={`${styles.subList} ${isExpanded ? styles.expanded : styles.collapsed} ${
							level === 2 ? styles.subListLevel3 : ''
						}`}>
						{item.children.map((child, childIndex) => (
							<LinkItem key={childIndex} item={child} level={level + 1} />
						))}
					</ul>
				</div>
			)}
		</li>
	)
}
